import { render, staticRenderFns } from "./ColumnGroup.vue?vue&type=template&id=7682771a&scoped=true&"
import script from "./ColumnGroup.vue?vue&type=script&lang=js&"
export * from "./ColumnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7682771a",
  null
  
)

export default component.exports